import { Icon, IconButton, ListItemIcon, Menu, MenuItem, Typography } from '@mui/material';
import React, { MouseEvent } from 'react';
import { withRouter, RouteComponentProps, Link } from 'react-router-dom';

import { RequireRole } from 'app/components/require-role';
import { MenuItemData } from 'app/model/menu-item';

interface HelpMenuProps extends RouteComponentProps {
    options: MenuItemData[];
    icon: string;
}

interface HelpMenuState {
    anchorEl?: Element;
}

class HeaderMenu extends React.Component<HelpMenuProps, HelpMenuState> {
    public constructor(props: HelpMenuProps | Readonly<HelpMenuProps>) {
        super(props);
        this.state = {};
    }

    public isOpen(): boolean {
        return undefined !== this.state.anchorEl;
    }

    public handleClick(evt: MouseEvent): void {
        this.setState({
            anchorEl: evt.currentTarget,
        });
    }

    public handleClose(): void {
        this.setState({
            anchorEl: undefined,
        });
    }

    public render(): React.ReactNode {
        const menuHeight = 252;
        const onClose = () => this.handleClose();

        return (
            <React.Fragment>
                <IconButton
                    aria-label='menu'
                    aria-controls='long-menu'
                    aria-haspopup='true'
                    color='inherit'
                    onClick={(evt) => this.handleClick(evt)}
                    size='large'
                >
                    <Icon>{this.props.icon}</Icon>
                </IconButton>

                <Menu
                    id='long-menu'
                    anchorEl={this.state.anchorEl}
                    keepMounted
                    open={this.isOpen()}
                    onClose={onClose}
                    PaperProps={{
                        style: {
                            maxHeight: menuHeight,
                            width: '20ch',
                        },
                    }}
                >
                    {this.props.options.map((option) => (
                        <RequireRole roles={option.role} key={option.name}>
                            {(() => {
                                return (
                                    <MenuItem
                                        component={option.target ? 'a' : option.routerLink ? Link : 'span'}
                                        target={option.target ?? undefined}
                                        href={option.target ? option.routerLink : undefined}
                                        to={option.routerLink && !option.target ? option.routerLink : undefined}
                                        onClick={(evt: React.MouseEvent) => {
                                            this.handleClose();
                                            if (!option.target && !option.routerLink && option.onClick) {
                                                option.onClick(evt);
                                            }
                                        }}
                                    >
                                        <ListItemIcon>
                                            <Icon>{option.icon}</Icon>
                                        </ListItemIcon>
                                        <Typography>{option.name}</Typography>
                                    </MenuItem>
                                );
                            })()}
                        </RequireRole>
                    ))}
                </Menu>
            </React.Fragment>
        );
    }
}

const enhanced = withRouter(HeaderMenu);

export { enhanced as HeaderMenu };
